import AppService from '../shared/App.api';

export default {
  uploadFile,
};

async function uploadFile(file) {
  const formData = new FormData();
  formData.append('file', file);

  const response = await AppService.postFile('/publish/upload', formData);

  if (response.status !== 200 || !response.data.url) {
    throw new Error('Failed to upload file', response);
  }

  return response.data.url;
}
